import { addons } from '@storybook/addons';
import maandagTheme from './maandag-theme';

addons.setConfig({
  theme: maandagTheme,
});
